export class MessaggioErroreDTO {
  messaggio: string;
  warning: boolean;
}
